import React from 'react'
import './styles.css'

const RadioBttn = (props) => (
  <div className={`radiobutton ${props.clickable && 'cursor-pointer'}`} onClick={props.onClick}>
    <div className={`circle-bttn ${props.selected && 'selected'}`} />
    <span className={`${props.selected && 'selected-text'}`}>{props.text}</span>
  </div>
)

export default RadioBttn



// WEBPACK FOOTER //
// ./src/components/common/buttons/RadioBttn.js